















import { PropType } from 'vue';
import { InstitutionProfileModel } from '../../models/institutionProfile.model';
import { InstitutionProfileMasterDataForm } from '../../../src/business/institutionProfileMasterDataForm';
import { portalRoles } from '../../enums/portalRoles';

export default {
  props: {
    institutionProfile: { type: Object as PropType<InstitutionProfileModel>, required: true },
    disabled: { type: Boolean, default: false },
    showInstitutionName: { type: Boolean, default: true },
    userRole: { type: String, default: '' },
  },
  emits: ['input'],
  data() {
    return {
      contactForm: new InstitutionProfileMasterDataForm(this.institutionProfile),
      portalRoles,
    };
  },
  computed: {
    isOtpUser() {
      return this.userRole === portalRoles.OTP;
    },
    label() {
      const institutionName = this.showInstitutionName ? this.institutionProfile.institutionName : null;
      if (!this.showInstitutionName) {
        return this.$t('user.email');
      } else {
        return this.$t('user.email_associated', { name: institutionName });
      }
    },
    hasFormatError() {
      return !this.contactForm.isValidEmail && this.contactForm.email !== '';
    },
  },
  methods: {
    emitInput() {
      if (this.contactForm.isEmailEmpty && this.contactForm.email.trim() !== '') {
        this.contactForm.isEmailEmpty = false;
      }
      this.$emit('input', this.contactForm);
    },
  },
};
